

class LocaleUtil {

  static translateFromPayload(jsonTrasnlationString, locale) {
    try {
        let term = JSON.parse(jsonTrasnlationString);
        if (term[locale] != undefined) {
          return term[locale];
        } else {
          return jsonTrasnlationString;
        }
      } catch (e) {
        return jsonTrasnlationString;
      }
  }

  static transformLocaleToLanguage(locale) {
    if(locale.length == 2) {
      return locale.toUpperCase();
    }
    else  {
      return "EN"; // natvrdo stanoveny default
    }
  }

}

module.exports = LocaleUtil;